import React from 'react';
const BlacklistTokenConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/blacklist-token',
			component: React.lazy(() => import('./BlacklistToken'))
		}
	]
};

export default BlacklistTokenConfig;
